import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Package, Heart, MapPin, LogOut, Edit3, Check } from 'lucide-react';
import Header24 from './components/Header24';
import Footer24 from './components/Footer24';

const Profile24 = () => {
    const navigate = useNavigate();
    const [activeSection, setActiveSection] = useState('profile');
    const [editing, setEditing] = useState(false);
    const [profile, setProfile] = useState({
        firstName: 'Ananya',
        lastName: 'Sharma',
        email: 'ananya@example.com',
        phone: '+91 98765 43210',
        address: '42 Lodhi Colony, New Delhi 110003',
    });

    const sidebarItems = [
        { key: 'profile', label: 'Profile', icon: User },
        { key: 'orders', label: 'Orders', icon: Package },
        { key: 'wishlist', label: 'Wishlist', icon: Heart },
        { key: 'addresses', label: 'Addresses', icon: MapPin },
    ];

    const handleChange = (field, value) => {
        setProfile(prev => ({ ...prev, [field]: value }));
    };

    const handleSave = () => {
        setEditing(false);
    };

    const inputStyle = {
        width: '100%',
        padding: '14px 16px',
        border: '1px solid #E5E5E5',
        fontFamily: "'Inter', sans-serif",
        fontSize: '14px',
        color: '#1A1A1A',
        background: '#FFFFFF',
        outline: 'none',
        transition: 'border-color 0.3s ease',
        boxSizing: 'border-box',
    };

    const labelStyle = {
        display: 'block',
        fontFamily: "'Inter', sans-serif",
        fontSize: '12px',
        fontWeight: 500,
        letterSpacing: '0.5px',
        color: '#6B6B6B',
        marginBottom: '8px',
    };

    const valueStyle = {
        fontFamily: "'Inter', sans-serif",
        fontSize: '15px',
        color: '#1A1A1A',
        padding: '14px 0',
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Inter:wght@300;400;500;600;700&display=swap');

                .dhara-profile {
                    min-height: 100vh;
                    background: #FFFFFF;
                }
                .dhara-profile-inner {
                    max-width: 1100px;
                    margin: 0 auto;
                    padding: 60px 40px 120px;
                }
                .dhara-profile-header {
                    margin-bottom: 60px;
                }
                .dhara-profile-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 42px;
                    font-weight: 400;
                    color: #1A1A1A;
                    margin-bottom: 8px;
                    letter-spacing: -0.5px;
                }
                .dhara-profile-greeting {
                    font-family: 'Inter', sans-serif;
                    font-size: 15px;
                    color: #6B6B6B;
                    font-weight: 300;
                }
                .dhara-profile-layout {
                    display: grid;
                    grid-template-columns: 240px 1fr;
                    gap: 80px;
                    align-items: start;
                }
                .dhara-profile-sidebar {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }
                .dhara-profile-sidebar-btn {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    padding: 14px 16px;
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #6B6B6B;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    text-align: left;
                    border-radius: 0;
                }
                .dhara-profile-sidebar-btn:hover {
                    color: #1A1A1A;
                    background: #FAFAF8;
                }
                .dhara-profile-sidebar-btn.active {
                    color: #00553A;
                    background: #F0F7F4;
                    font-weight: 500;
                }
                .dhara-profile-logout {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    padding: 14px 16px;
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #6B6B6B;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    margin-top: 24px;
                    border-top: 1px solid #E5E5E5;
                    padding-top: 28px;
                    transition: color 0.3s ease;
                }
                .dhara-profile-logout:hover {
                    color: #C53030;
                }

                .dhara-profile-content {
                    /* Content area */
                }
                .dhara-profile-section-title {
                    font-family: 'Inter', sans-serif;
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    color: #1A1A1A;
                    margin-bottom: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
                .dhara-profile-edit-btn {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    color: #00553A;
                    background: none;
                    border: none;
                    cursor: pointer;
                    font-weight: 400;
                    letter-spacing: 0;
                    text-transform: none;
                    transition: opacity 0.3s ease;
                }
                .dhara-profile-edit-btn:hover {
                    opacity: 0.7;
                }
                .dhara-profile-field {
                    margin-bottom: 24px;
                    border-bottom: 1px solid #F5F5F5;
                    padding-bottom: 24px;
                }
                .dhara-profile-field:last-child {
                    border-bottom: none;
                }
                .dhara-profile-save-btn {
                    padding: 14px 40px;
                    background: #00553A;
                    color: #FFFFFF;
                    border: none;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    font-weight: 500;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                    cursor: pointer;
                    transition: background 0.3s ease;
                    margin-top: 12px;
                }
                .dhara-profile-save-btn:hover {
                    background: #006B4A;
                }
                .dhara-profile-cancel-btn {
                    padding: 14px 40px;
                    background: transparent;
                    color: #6B6B6B;
                    border: 1px solid #E5E5E5;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    cursor: pointer;
                    margin-left: 12px;
                    transition: border-color 0.3s ease;
                }
                .dhara-profile-cancel-btn:hover {
                    border-color: #1A1A1A;
                    color: #1A1A1A;
                }

                input:focus {
                    border-color: #00553A !important;
                }

                @media (max-width: 768px) {
                    .dhara-profile-inner { padding: 40px 20px 80px; }
                    .dhara-profile-title { font-size: 32px; }
                    .dhara-profile-layout {
                        grid-template-columns: 1fr;
                        gap: 40px;
                    }
                    .dhara-profile-sidebar {
                        flex-direction: row;
                        overflow-x: auto;
                        gap: 0;
                        border-bottom: 1px solid #E5E5E5;
                        padding-bottom: 0;
                    }
                    .dhara-profile-sidebar-btn {
                        white-space: nowrap;
                        padding: 12px 16px;
                        font-size: 13px;
                    }
                    .dhara-profile-logout {
                        border-top: none;
                        margin-top: 0;
                        padding-top: 12px;
                    }
                }
            `}</style>

            <Header24 />

            <main className="dhara-profile">
                <div className="dhara-profile-inner">
                    <div className="dhara-profile-header">
                        <h1 className="dhara-profile-title">My Account</h1>
                        <p className="dhara-profile-greeting">
                            Welcome back, {profile.firstName}.
                        </p>
                    </div>

                    <div className="dhara-profile-layout">
                        {/* Sidebar */}
                        <div>
                            <div className="dhara-profile-sidebar">
                                {sidebarItems.map(item => (
                                    <button
                                        key={item.key}
                                        className={`dhara-profile-sidebar-btn ${activeSection === item.key ? 'active' : ''}`}
                                        onClick={() => {
                                            if (item.key === 'orders') {
                                                navigate('/template24/orders');
                                            } else {
                                                setActiveSection(item.key);
                                            }
                                        }}
                                    >
                                        <item.icon size={18} strokeWidth={1.5} />
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                            <button
                                className="dhara-profile-logout"
                                onClick={() => navigate('/template24/login')}
                            >
                                <LogOut size={18} strokeWidth={1.5} />
                                Sign Out
                            </button>
                        </div>

                        {/* Content */}
                        <div className="dhara-profile-content">
                            {activeSection === 'profile' && (
                                <>
                                    <div className="dhara-profile-section-title">
                                        Personal Information
                                        <button
                                            className="dhara-profile-edit-btn"
                                            onClick={() => setEditing(!editing)}
                                        >
                                            {editing ? (
                                                <><Check size={16} strokeWidth={1.5} /> Done</>
                                            ) : (
                                                <><Edit3 size={16} strokeWidth={1.5} /> Edit</>
                                            )}
                                        </button>
                                    </div>

                                    <div className="dhara-profile-field">
                                        <label style={labelStyle}>First Name</label>
                                        {editing ? (
                                            <input
                                                style={inputStyle}
                                                value={profile.firstName}
                                                onChange={(e) => handleChange('firstName', e.target.value)}
                                            />
                                        ) : (
                                            <div style={valueStyle}>{profile.firstName}</div>
                                        )}
                                    </div>

                                    <div className="dhara-profile-field">
                                        <label style={labelStyle}>Last Name</label>
                                        {editing ? (
                                            <input
                                                style={inputStyle}
                                                value={profile.lastName}
                                                onChange={(e) => handleChange('lastName', e.target.value)}
                                            />
                                        ) : (
                                            <div style={valueStyle}>{profile.lastName}</div>
                                        )}
                                    </div>

                                    <div className="dhara-profile-field">
                                        <label style={labelStyle}>Email</label>
                                        {editing ? (
                                            <input
                                                style={inputStyle}
                                                type="email"
                                                value={profile.email}
                                                onChange={(e) => handleChange('email', e.target.value)}
                                            />
                                        ) : (
                                            <div style={valueStyle}>{profile.email}</div>
                                        )}
                                    </div>

                                    <div className="dhara-profile-field">
                                        <label style={labelStyle}>Phone</label>
                                        {editing ? (
                                            <input
                                                style={inputStyle}
                                                value={profile.phone}
                                                onChange={(e) => handleChange('phone', e.target.value)}
                                            />
                                        ) : (
                                            <div style={valueStyle}>{profile.phone}</div>
                                        )}
                                    </div>

                                    {editing && (
                                        <div style={{ marginTop: '8px' }}>
                                            <button className="dhara-profile-save-btn" onClick={handleSave}>
                                                Save Changes
                                            </button>
                                            <button className="dhara-profile-cancel-btn" onClick={() => setEditing(false)}>
                                                Cancel
                                            </button>
                                        </div>
                                    )}
                                </>
                            )}

                            {activeSection === 'wishlist' && (
                                <>
                                    <div className="dhara-profile-section-title">Saved Pieces</div>
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '60px 20px',
                                        fontFamily: "'Inter', sans-serif",
                                        color: '#6B6B6B',
                                        fontSize: '15px',
                                    }}>
                                        <Heart size={40} strokeWidth={1} style={{ color: '#E5E5E5', marginBottom: '20px' }} />
                                        <p>Your wishlist is empty.</p>
                                        <button
                                            onClick={() => navigate('/template24/shop')}
                                            style={{
                                                marginTop: '24px',
                                                padding: '12px 32px',
                                                background: '#00553A',
                                                color: '#FFFFFF',
                                                border: 'none',
                                                fontFamily: "'Inter', sans-serif",
                                                fontSize: '13px',
                                                letterSpacing: '1.5px',
                                                textTransform: 'uppercase',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Explore Collection
                                        </button>
                                    </div>
                                </>
                            )}

                            {activeSection === 'addresses' && (
                                <>
                                    <div className="dhara-profile-section-title">
                                        Saved Addresses
                                        <button className="dhara-profile-edit-btn">
                                            <Edit3 size={16} strokeWidth={1.5} /> Add New
                                        </button>
                                    </div>
                                    <div style={{
                                        border: '1px solid #E5E5E5',
                                        padding: '24px',
                                    }}>
                                        <div style={{
                                            fontFamily: "'Inter', sans-serif",
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            color: '#1A1A1A',
                                            marginBottom: '8px',
                                        }}>
                                            {profile.firstName} {profile.lastName}
                                        </div>
                                        <div style={{
                                            fontFamily: "'Inter', sans-serif",
                                            fontSize: '14px',
                                            color: '#6B6B6B',
                                            lineHeight: 1.7,
                                        }}>
                                            {profile.address}<br />
                                            {profile.phone}
                                        </div>
                                        <div style={{
                                            display: 'inline-block',
                                            marginTop: '12px',
                                            padding: '4px 10px',
                                            background: '#F0F7F4',
                                            fontFamily: "'Inter', sans-serif",
                                            fontSize: '11px',
                                            color: '#00553A',
                                            fontWeight: 500,
                                        }}>
                                            Default
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </main>

            <Footer24 />
        </>
    );
};

export default Profile24;
